export default "__VITE_ASSET__86fd45e9__"